import React, { useState } from "react";
import { del, post } from "../lib/api";
import { SNOOZE_PRESETS, addDays, formatDay } from "../lib/format";
import { todayISO } from "../../helpers/datetime";
import { Button, Input, Menu, MenuItem } from "../ui";
import { useShell } from "../shell/context";

// Snooze until a date (POST/DELETE /v1/crm/{contacts|companies}/:id/snooze).
export default function SnoozeMenu({ base, entity, onChanged }) {
    const { toast } = useShell();
    const [custom, setCustom] = useState("");
    const today = todayISO();
    const snoozed = entity.snoozed_until && entity.snoozed_until > today;

    const snooze = async (until) => {
        try {
            const res = await post(`v1/crm/${base}/${entity.id}/snooze`, { until });
            toast(`Snoozed until ${formatDay(until, { short: true })}.`, { icon: "ri-zzz-line" });
            onChanged(res);
        } catch (e) {
            toast(e.message, { error: true });
        }
    };
    const clear = async () => {
        try {
            const res = await del(`v1/crm/${base}/${entity.id}/snooze`);
            toast("Snooze cleared.");
            onChanged(res);
        } catch (e) {
            toast(e.message, { error: true });
        }
    };

    return (
        <Menu
            trigger={(open, toggle) => (
                <Button variant="outline" icon="ri-zzz-line" onClick={toggle}>
                    Snooze <i className="ri-arrow-down-s-line"></i>
                </Button>
            )}
        >
            {SNOOZE_PRESETS.map((p) => (
                <MenuItem key={p.days} sub={formatDay(addDays(today, p.days), { short: true })} onClick={() => snooze(addDays(today, p.days))}>
                    {p.label}
                </MenuItem>
            ))}
            <div className="hz-menu-sep"></div>
            <div style={{ padding: "6px 14px" }} onClick={(e) => e.stopPropagation()}>
                <div className="hz-small hz-muted" style={{ marginBottom: 4 }}>Until a date</div>
                <div className="hz-row" style={{ gap: 6 }}>
                    <Input small type="date" min={addDays(today, 1)} value={custom} onChange={(e) => setCustom(e.target.value)} />
                    <Button size="sm" variant="primary" disabled={!custom} onClick={() => snooze(custom)}>Set</Button>
                </div>
            </div>
            {snoozed && (
                <>
                    <div className="hz-menu-sep"></div>
                    <MenuItem danger onClick={clear}>Clear snooze</MenuItem>
                </>
            )}
        </Menu>
    );
}
